"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOK = exports.BOOKS = void 0;
const client_1 = require("@apollo/client");
exports.BOOKS = (0, client_1.gql) `
  query Books {
    books {
      id
      name
      avatar
    }
  }
`;
exports.BOOK = (0, client_1.gql) `
  query Book($bookId: Int!) {
    book(id: $bookId) {
      id
      name
      publishDate
      publisher
      pages
      language
      format
      avatar
      price
      ISBN
      type
      description
      heroImg
      chapters
      stripePriceId
      authors {
        id
        name
        linkedIn
        avatar
        description
        title
        qualifications
        twitter
      }
    }
  }
`;
